import {graphql} from 'react-relay';
import {Disposable, Environment} from 'relay-runtime';
import Util from '../forecast-app/shared/util/util';
import {trackAndCommitMutation} from '../tracking/amplitude/TrackMutation';
import {
	ReorderProjectStagesMutation,
	ReorderProjectStagesMutation$data,
} from './__generated__/ReorderProjectStagesMutation.graphql';

type ReorderProjectStagesInput = {
	ids: ReadonlyArray<string>;
};

// The payload re-reads the page's stage connection, so Relay's cached list takes the saved order.
const mutation = graphql`
	mutation ReorderProjectStagesMutation($input: ReorderProjectStagesInput!) {
		reorderProjectStages(input: $input) {
			company {
				id
				projectStages(first: 1000) @connection(key: "Company_projectStages") {
					edges {
						node {
							__typename
							id
							name
							sortOrder
							... on DefaultProjectStage {
								defaultStage
							}
						}
					}
				}
			}
		}
	}
`;

function commit(
	environment: Environment,
	input: ReorderProjectStagesInput,
	onSuccess?: (response: ReorderProjectStagesMutation$data) => void,
	onError?: (error: Error) => void
): Disposable {
	return trackAndCommitMutation<ReorderProjectStagesMutation>(environment, {
		mutation,
		variables: {
			input: {
				csrfToken: Util.getCsrfValue(),
				socketClientId: Util.getClientId(),
				ids: input.ids,
			},
		},
		onCompleted: onSuccess,
		onError,
	});
}

export default {commit};
